

let isEnabled: boolean | undefined;
let ppvSpecificDiscountPercentage : string | undefined;

function ringPassDiscountEnabled() {
    if (typeof isEnabled !== 'undefined') {
        return isEnabled;
    }

    try {
        const isFeatureEnabled = window.dazn.features.isEnabledAnonymous('f_ar_ringpass');
        isEnabled = isFeatureEnabled;
        return isEnabled;
    } catch (e) {
        return false;
    }
}

function getPpvSpecificDiscountPercentage() {
    if (
        ppvSpecificDiscountPercentage !== undefined &&
        typeof ppvSpecificDiscountPercentage !== 'string'
    ) {
        return ppvSpecificDiscountPercentage;
    }
    try {
        ppvSpecificDiscountPercentage = window.dazn.features.getVariableStringAnonymous('f_ar_ringpass', 'ppvSpecificPercentage')
        if (typeof ppvSpecificDiscountPercentage === 'string') {
            return JSON.parse(ppvSpecificDiscountPercentage);
        }
        return {};
    } catch (e) {
        return {};
    }
}

function getPpvDefaultDiscountPercentage() {
    try {
        const ppvDefaultDiscountPercentage = window.dazn.features.getVariableIntegerAnonymous('f_ar_ringpass', 'defaultDiscountPercentage')
        return ppvDefaultDiscountPercentage;
    } catch (e) {
        return 0;
    }
}

function disabledDiscountedPpv(): string[] {
    const jsonString = window.dazn.features.getVariableStringAnonymous('f_ar_ringpass', 'disabledDiscountedPpv') ?? false;
    try {
     return JSON.parse(jsonString ?? '[]');
 } catch (error) {
     console.error('Error parsing JSON in ringpass key:', error);
     return [];
 }
 
 }

export {
    ringPassDiscountEnabled,
    getPpvSpecificDiscountPercentage,
    getPpvDefaultDiscountPercentage,
    disabledDiscountedPpv,
};